import React from "react";
import { InfoBanner } from "@services/ui-components";
import { useTranslation } from "react-i18next";

type RoleManagementInfoBannerProps = {
    variant: "list" | "details";
};

const keyByVariant: Record<"list" | "details", string> = {
    list: "This page shows the list of all access roles in the company. You can create new roles with your own settings.",
    details:
        "On this page, you can view and configure access permissions for a specific role (except for default roles, which cannot be edited).",
};

const RoleManagementInfoBanner: React.FC<RoleManagementInfoBannerProps> = ({ variant }) => {
    const { t } = useTranslation();
    return (
        <InfoBanner iconClassColor="text-violet-hover">
            <p className="fs-7 mb-0">{t(keyByVariant[variant])}</p>
        </InfoBanner>
    );
};

export default RoleManagementInfoBanner;
